import { Component } from "@angular/core";
import { CustomModal } from "../../../../../core/components/base-modals/custom-modal";
import { Security2FAEnableModalComponent } from "../enable-modal/security-2fa-enable-modal.component";

@Component({
	templateUrl: "./security-2fa-enforce-modal.component.html",
	styleUrls: ["./security-2fa-enforce-modal.component.scss"],
	standalone: false
})
export class Security2FAEnforceModalComponent extends CustomModal {
	public onCancel2FA(): void {
		this.close();
	}

	public onStart2FA(): void {
		this.close();
		this.modalService.create(Security2FAEnableModalComponent).present();
	}
}
